import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Hero from '../components/sections/Hero';
import VisionSection from '../components/sections/VisionSection';
import Typologies from '../components/sections/Typologies';
import GolfSection from '../components/sections/GolfSection';
import Masterplan from '../components/sections/Masterplan';
import Accessibility from '../components/sections/Accessibility';
import CTA from '../components/sections/CTA';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-[#FAFAFA]" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <VisionSection />
        <Typologies />
        <GolfSection />
        <Masterplan />
        <Accessibility />
        <CTA />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
